import { AppleLogo, GoogleLogo } from '../../ui/icons';

/** Apple + Google sign-in buttons. */
export function SocialButtons({
  onApple,
  onGoogle,
  disabled
}: {
  onApple: () => void;
  onGoogle: () => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-col gap-3">
      <button
        type="button"
        disabled={disabled}
        onClick={onApple}
        className="tap flex w-full items-center justify-center gap-[10px] rounded-full bg-night py-[14px] text-[15px] font-bold text-white shadow-dark disabled:opacity-50"
      >
        <AppleLogo width={18} height={18} className="-mt-[2px]" />
        Continue with Apple
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={onGoogle}
        className="tap flex w-full items-center justify-center gap-[10px] rounded-full border border-black/10 bg-card py-[14px] text-[15px] font-bold text-ink shadow-tile disabled:opacity-50"
      >
        <GoogleLogo width={18} height={18} />
        Continue with Google
      </button>
    </div>
  );
}
